import React, { FC, useEffect, useState } from 'react';
import axios from 'axios';
import { getRevokeUrl } from 'utils/baseUrl';
import { getBearerToken, getClientId, getEnv, removeBearerToken } from 'utils/sessionStorage';
import { ButtonContainer, CustomButton } from './LogoutButton.styles';
import { GLOBAL_EVENTS } from 'utils/constants';
import { LogOutIcon } from '@nab/nui-react';

interface ILogoutButton {
    actions: any;
    signOutRoute: string;
}

const revokeToken = async () => {
    await axios.post(
        `${getRevokeUrl(getEnv())}/v1/idp/oauth/revoke`,
        {
            token: getBearerToken(),
            client_id: getClientId()
        },
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );
};

const LogoutButton: FC<ILogoutButton> = ({ actions, signOutRoute }) => {
    const [logoutButtonShown, setLogoutButtonShown] = useState<boolean>(false);
    const getRedirectURL = (signOutRoute: string) => {
        if (signOutRoute.startsWith('https')) {
            return `${signOutRoute}`;
        } else {
            return window.location.origin + `/${signOutRoute}`;
        }
    };

    //revoke token and logout
    const handleClick = async () => {
        await revokeToken();
        setLogoutButtonShown(false);
        removeBearerToken();
        //from theme configs
        window.location.href = getRedirectURL(signOutRoute);
    };

    useEffect(() => {
        //listen to global logout event from miniapp
        actions.addEventListener(GLOBAL_EVENTS.LOGOUT, async (data) => {
            await revokeToken();
            removeBearerToken();
            setLogoutButtonShown(false);
            if (!data?.func) {
                window.location.href = getRedirectURL(signOutRoute);
            } else {
                data.func();
            }
        });
    }, []);

    // Check log-in state in every render
    useEffect(() => {
        setLogoutButtonShown(getBearerToken() != null);
    });

    return (
        <>
            {logoutButtonShown ? (
                <ButtonContainer>
                    <CustomButton label="log out button" icon={LogOutIcon} isOnDarkBg onClick={handleClick} />
                </ButtonContainer>
            ) : null}
        </>
    );
};
export default LogoutButton;
